<ng-container *ngIf="scheduleForm" [formGroup]="scheduleForm">
  <div>
    <h3 class="text-uppercase">{{ schedulePayoffKey }} Schedule</h3>
  </div>

  <div class="form-row">
    <div
      class="form-group col-lg-2 col-min scheduleType"
      *ngIf="fieldsVisiblity?.scheduleType()"
    >
      <app-dc-select
        formControlName="scheduleType"
        [labelId]="'scheduleType'"
        label="Type"
        [items]="scheduleTypeItems"
        closeOnSelect="true"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
    <div
      class="form-group col-lg-1 col-min pmtScheduleLag"
      *ngIf="fieldsVisiblity?.pmtScheduleLag()"
    >
      <app-dc-select
        #pmtScheduleRef
        formControlName="pmtScheduleLag"
        [labelId]="'pmtScheduleLag'"
        label="Payment Lag"
        [items]="scheduleLagItems"
        closeOnSelect="true"
        [searchable]="true"
        [FreeText]="true"
        [clearSelection]="true"
        (selected)="updateField(pmtScheduleRef)"
      ></app-dc-select>
    </div>
    <div
      class="form-group col-lg-2 col-min pmtScheduleLag"
      *ngIf="fieldsVisiblity?.pmtScheduleLag()"
    >
      <app-dc-select
        #pmtScheduleBaseRef
        formControlName="pmtScheduleLagBase"
        [labelId]="'pmtScheduleLag'"
        label="Payment Lag Base"
        [items]="pmtLagBaseOptions"
        closeOnSelect="true"
        [clearSelection]="true"
        (selected)="updateField(pmtScheduleBaseRef)"
      ></app-dc-select>
    </div>
    <div
      *ngIf="fieldsVisiblity?.refRateFixingLag()"
      class="form-group col-lg-2 col-min refRateFixingLag"
    >
      <app-dc-select
        formControlName="refRateFixingLag"
        [labelId]="'refRateFixingLag'"
        [label]="referenceRateLagLabel"
        [items]="scheduleLagItems"
        closeOnSelect="true"
        [searchable]="true"
        [FreeText]="true"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
    <div
      class="form-group col-lg-2 col-min accrualPeriodType"
      *ngIf="fieldsVisiblity?.accrualScheduleLagBase()"
    >
      <app-dc-select
        formControlName="accrualScheduleLagBase"
        label="Accrual Lag Base"
        [items]="accrualScheduleLagBaseTypes"
        closeOnSelect="true"
        [searchable]="true"
        [FreeText]="true"
        [clearSelection]="false"
      ></app-dc-select>
    </div>
    <div
      class="form-group col-lg-1 col-min pmtScheduleLag"
      *ngIf="fieldsVisiblity?.callNoticeLag()"
    >
      <app-dc-select
        formControlName="callNoticeLag"
        [labelId]="'callNoticeLag'"
        label="Call Notice Lag"
        [items]="scheduleLagItems"
        closeOnSelect="true"
        [searchable]="true"
        [FreeText]="true"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
    <div
      class="form-group col-lg-2 col-min pmtScheduleLag"
      *ngIf="fieldsVisiblity?.callNoticeLag()"
    >
      <app-dc-select
        formControlName="callNoticeLagBaseType"
        labelId="callNoticeLagBaseType"
        label="Call Notice Lag Base Type"
        [items]="callNoticeLagBaseItems"
        closeOnSelect="true"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
    <div
      class="form-group col-lg-2 col-min pmtScheduleLag"
      *ngIf="fieldsVisiblity?.lastPeriodCallable()"
    >
      <app-dc-select
        [formControl]="featureForm.get('lastPeriodCallable')"
        labelId="lastPeriodCallable"
        label="Last Period Callable"
        [items]="YES_NO"
        closeOnSelect="true"
        [clearSelection]="true"
      ></app-dc-select>
    </div>
    <div *ngIf="fieldsVisiblity?.scheduleType()"
      class="col-lg-2 mb-3 btn-container"
      placement="top"
      [ngbTooltip]="!scheduleTypeValue ? 'Please select a schedule type' : ''"
    >
      <button
        class="btn btn-primary"
        [disabled]="!scheduleTypeValue || !canUserEdit"
        (click)="openRollDaysModal(rollDaysModal)"
      >
        Roll days
      </button>
    </div>
  </div>

  <div *ngIf="scheduleData?.length">
    <div class="form-row labelContainer">
      <div class="col-lg-1" style="max-width: 50px">
        <label class="colHeader">Period</label>
      </div>
      <div class="col-lg-2" *ngIf="scheduleRowColumnVisibility.callNoticeDate">
        <label class="colHeader">Call Notice Date</label>
      </div>
      <div class="col-lg-1" *ngIf="scheduleRowColumnVisibility.barrierLevel">
        <label class="colHeader">Barrier Level</label>
      </div>

      <div class="col-lg-1" *ngIf="scheduleRowColumnVisibility.rangeAccrualRate">
        <label class="colHeader">Coupon Rate</label>
      </div>
      <div class="col-lg-1" *ngIf="scheduleRowColumnVisibility.lowerLevel">
        <label class="colHeader">Lower Barrier</label>
      </div>
      <div class="col-lg-1" *ngIf="scheduleRowColumnVisibility.upperLevel">
        <label class="colHeader">Upper Barrier</label>
      </div>
      <div
        class="col-lg-1"
        *ngIf="scheduleRowColumnVisibility.redemptionAmountPayable_relative"
      >
        <label class="colHeader">Redemption Amt.</label>
      </div>
      <div
        class="col-lg-2 unadjObsDate"
        [style.maxWidth]="templateSettings.obsDateColWidth"
        *ngIf="scheduleRowColumnVisibility.unadjObsDate"
      >
        <label class="colHeader">Unadj. Obs. Date</label>
      </div>
      <div
        *ngIf="scheduleRowColumnVisibility.adjObsDate"
        class="col-lg-2"
        [style.maxWidth]="templateSettings.obsDateColWidth"
      >
        <label class="colHeader">Adj. Obs. Date</label>
      </div>
      <div
        *ngIf="scheduleRowColumnVisibility.rateDeterminationDate"
        class="col-lg-2"
      >
        <label class="colHeader">Ref. Rate Fixing</label>
      </div>
      <ng-container>
        <div
          class="col-lg-2"
          *ngIf="scheduleRowColumnVisibility.accrualStartDate"
        >
          <label class="colHeader accrualStartDate">Accrual Start Date</label>
        </div>
        <div
          class="col-lg-2"
          *ngIf="scheduleRowColumnVisibility.accrualEndDate"
        >
          <label class="colHeader accrualEndDate">Accrual End Date</label>
        </div>
        <div
          class="col-lg-2"
          [style.maxWidth]="templateSettings.obsDateColWidth"
          *ngIf="scheduleRowColumnVisibility.unadjPmtDate"
        >
          <label class="colHeader unadjPmtDate">Unadj. Payment Date</label>
        </div>
        <div class="col-lg-1">
          <label class="colHeader adjPmtDate">Adj. Payment Date</label>
        </div>
      </ng-container>
      <div class="col-lg-1" style="max-width: 50px">
        <label class="colHeader"></label>
      </div>
    </div>
    <app-dc-loading *ngIf="isRefreshing"></app-dc-loading>
    <ng-container *ngIf="!isRefreshing">
      <div class="schedule-list" *ngIf="scheduleData?.length; else noResults">
        <div *ngFor="let row of scheduleData; let i = index; let last = last">
          <app-schedule-row
            [scheduleForm]="scheduleForm"
            [featureForm]="featureForm"
            [groupName]="i"
            (rowUpdated)="updateProduct()"
            [templateSettings]="templateSettings"
            [barrierObservable$]="barrierObservable$"
            [columnVisibility]="scheduleRowColumnVisibility"
            [isHidden]="hideLastRow && last"
            [type]="key"
          ></app-schedule-row>
        </div>
      </div>
    </ng-container>

    <ng-template #noResults>
      <div
        class="p-5 m-5 text-center text-muted no-results"
        style="min-height: 200px"
      >
        No results
      </div>
    </ng-template>
  </div>
</ng-container>
<app-roll-days-modal #rollDaysModal [form]="scheduleForm" [scheduleKey]="key">
</app-roll-days-modal>
